/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Org_ChartInputs */

const es_tools_legajox_org_chart = /** @type {(inputs: Tools_Legajox_Org_ChartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultando organigrama en Legajox...`)
};

const en_tools_legajox_org_chart = /** @type {(inputs: Tools_Legajox_Org_ChartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Querying Legajox org chart...`)
};

/**
* | output |
* | --- |
* | "Querying Legajox org chart..." |
*
* @param {Tools_Legajox_Org_ChartInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_org_chart = /** @type {((inputs?: Tools_Legajox_Org_ChartInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Org_ChartInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_org_chart(inputs)
	return en_tools_legajox_org_chart(inputs)
});
export { tools_legajox_org_chart as "tools.legajox.org_chart" }